import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { Button } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { useCreateRoom } from "../api/queries";
import { RoomForm } from "../ui/rooms/RoomForm";

export function RoomCreatePage() {
  const nav = useNavigate({ from: "/app/master/rooms/create" });
  const createRoom = useCreateRoom();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ຫ້ອງຮຽນ", to: "/app/master/rooms" },
            { label: "ສ້າງ" },
          ]}
        />
      </Header>

      <Main>
        <div className="flex flex-wrap items-center justify-between space-y-2">
          <div>
            <h2 className="flex items-center font-bold text-2xl tracking-tight">
              ສ້າງຫ້ອງຮຽນ
            </h2>
            <p className="text-muted-foreground">ສ້າງຫ້ອງຮຽນໃໝ່ໃນລະບົບ.</p>
          </div>

          <Button
            variant="outline"
            onClick={() => nav({ to: "/app/master/rooms" })}
          >
            <ArrowLeftIcon className="size-4" />
            ກັບຄືນ
          </Button>
        </div>

        <div className="mt-6 rounded-xl border bg-card p-6">
          <RoomForm
            onSubmit={async (vals) => {
              try {
                await createRoom.mutateAsync(vals);

                nav({ to: "/app/master/rooms" });
              } catch (error) {
                // Error handling is done by the mutation
              }
            }}
            submitting={createRoom.isPending}
          />
        </div>
      </Main>
    </>
  );
}
